export default function Solution() {
  const solutions = [
    {
      icon: 'ri-flashlight-line',
      title: '즉시 매칭',
      description: '급하게 필요한 인력을 빠르게 연결해드립니다',
      color: 'emerald'
    },
    {
      icon: 'ri-shield-check-line',
      title: '검증된 인력',
      description: '경력과 평판이 확인된 신뢰할 수 있는 인력풀',
      color: 'blue'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: '합리적 비용',
      description: '성공 기반 과금으로 부담 없이 시작하세요',
      color: 'violet'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '전담 매니저',
      description: '채용부터 관리까지 전문가가 함께합니다',
      color: 'amber'
    }
  ];

  const colorClasses = {
    emerald: 'bg-emerald-100 text-emerald-600 group-hover:bg-emerald-600',
    blue: 'bg-blue-100 text-blue-600 group-hover:bg-blue-600',
    violet: 'bg-violet-100 text-violet-600 group-hover:bg-violet-600',
    amber: 'bg-amber-100 text-amber-600 group-hover:bg-amber-600'
  };

  return (
    <section className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-block px-4 py-2 bg-gray-100 rounded-full mb-6">
            <span className="text-sm font-medium text-gray-900" style={{ fontFamily: "'Pretendard', sans-serif" }}>온니잡의 솔루션</span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Pretendard', sans-serif", letterSpacing: '-0.02em' }}>
            이렇게 해결합니다
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" style={{ fontFamily: "'Pretendard', sans-serif" }}>
            사장님의 시간과 비용을 아껴드리는 스마트한 채용 시스템
          </p>
        </div>

        {/* Solutions Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {solutions.map((solution, index) => (
            <div 
              key={index}
              className="group bg-gray-50 rounded-2xl p-8 hover:bg-gray-900 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-14 h-14 ${colorClasses[solution.color as keyof typeof colorClasses]} rounded-xl flex items-center justify-center mb-6 transition-all duration-300 group-hover:text-white`}>
                <i className={`${solution.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-white transition-colors duration-300" style={{ fontFamily: "'Pretendard', sans-serif" }}>
                {solution.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed group-hover:text-gray-300 transition-colors duration-300" style={{ fontFamily: "'Pretendard', sans-serif" }}>
                {solution.description}
              </p>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="mt-24 grid md:grid-cols-3 gap-8">
          <div className="text-center">
            <p className="text-5xl font-bold text-gray-900 mb-2" style={{ fontFamily: "'Pretendard', sans-serif" }}>2.5시간</p>
            <p className="text-base text-gray-600" style={{ fontFamily: "'Pretendard', sans-serif" }}>평균 채용 소요 시간</p>
          </div>
          <div className="text-center">
            <p className="text-5xl font-bold text-gray-900 mb-2" style={{ fontFamily: "'Pretendard', sans-serif" }}>98%</p>
            <p className="text-base text-gray-600" style={{ fontFamily: "'Pretendard', sans-serif" }}>사장님 만족도</p>
          </div>
          <div className="text-center">
            <p className="text-5xl font-bold text-gray-900 mb-2" style={{ fontFamily: "'Pretendard', sans-serif" }}>1,200+</p>
            <p className="text-base text-gray-600" style={{ fontFamily: "'Pretendard', sans-serif" }}>검증된 인력풀</p>
          </div>
        </div>
      </div>
    </section>
  );
}
